import React, { memo } from 'react';
import classnames from 'classnames';

import Mark from 'components/Editor/buttons/Mark';
import Highlight from 'components/Editor/buttons/Highlight';
import Heading from 'components/Editor/buttons/Heading';
import Blockquote from 'components/Editor/buttons/Blockquote';
import Align from 'components/Editor/buttons/Align';
import Link from 'components/Editor/buttons/Link';
import Image from 'components/Editor/buttons/Image';
import Video from 'components/Editor/buttons/Video';
import Audio from 'components/Editor/buttons/Audio';
import Download from 'components/Editor/buttons/Download';
import Youtube from 'components/Editor/buttons/Youtube';
import Formula from 'components/Editor/buttons/Formula';
import Table from 'components/Editor/buttons/Table';
import List from 'components/Editor/buttons/List';
import Spellcheck from 'components/Editor/buttons/Spellcheck';
import Quiz from 'components/Editor/buttons/Quiz';
import History from 'components/Editor/buttons/History';

const Toolbar = memo(({ type, path, folder }) => {
	// Concat default toolbar classnames
	const defaultClassName = classnames(
		'relative flex border-b border-neutral-200 dark:border-neutral-700 flex-wrap transition-colors'
	);

	// Concat material toolbar classnames
	const materialClassName = classnames(
		'sticky z-[1] top-[4.5rem] flex border bg-white dark:bg-neutral-800 border-neutral-200 rounded-lg dark:border-neutral-700 flex-wrap transition-colors'
	);

	switch (type) {
	case 'answer':
		return (
			<div className={defaultClassName}>
				<Mark format="bold" icon="format_bold" />
				<Mark format="italic" icon="format_italic" />
				<Mark format="underline" icon="format_underlined" />
				<Mark format="strikethrough" icon="strikethrough_s" />
				<Mark format="superscript" icon="superscript" />
				<Mark format="subscript" icon="subscript" />
				<Highlight />

				<Image folder={folder} path={path} />

				<Formula />

				<History format="undo" icon="undo" />
				<History format="redo" icon="redo" />
			</div>
		);
	case 'question':
		return (
			<div className={defaultClassName}>
				<Mark format="bold" icon="format_bold" />
				<Mark format="italic" icon="format_italic" />
				<Mark format="underline" icon="format_underlined" />
				<Mark format="strikethrough" icon="strikethrough_s" />
				<Mark format="superscript" icon="superscript" />
				<Mark format="subscript" icon="subscript" />
				<Highlight />

				<Align />

				<Image folder={folder} path={path} />
				<Video folder={folder} path={path} />
				<Audio folder={folder} path={path} />
				<Download folder={folder} path={path} />
				<Youtube />
				
				<Formula />

				<History format="undo" icon="undo" />
				<History format="redo" icon="redo" />
			</div>
		);
	case 'spellcheck':
		return (
			<div className={defaultClassName}>
				<Mark format="bold" icon="format_bold" />
				<Mark format="italic" icon="format_italic" />
				<Mark format="underline" icon="format_underlined" />
				<Mark format="strikethrough" icon="strikethrough_s" />
				<Mark format="superscript" icon="superscript" />
				<Mark format="subscript" icon="subscript" />
				<Highlight />

				<Align />

				<Image folder={folder} path={path} />
				<Video folder={folder} path={path} />
				<Audio folder={folder} path={path} />
				
				<Formula />

				<Spellcheck />

				<History format="undo" icon="undo" />
				<History format="redo" icon="redo" />
			</div>
		);
	case 'material':
		return (
			<div className={materialClassName}>
				<Heading icon="looks_one" format="heading-one" />
				<Heading icon="looks_two" format="heading-two" />
				<Heading icon="looks_3" format="heading-three" />

				<Mark format="bold" icon="format_bold" />
				<Mark format="italic" icon="format_italic" />
				<Mark format="underline" icon="format_underlined" />
				<Mark format="strikethrough" icon="strikethrough_s" />
				<Mark format="superscript" icon="superscript" />
				<Mark format="subscript" icon="subscript" />
				<Highlight />

				<Align />
				
				<Blockquote format="blockquote" icon="format_quote" />

				<Link />

				<Image folder={folder} path={path} />
				<Video folder={folder} path={path} />
				<Audio folder={folder} path={path} />
				<Download folder={folder} path={path} />
				<Youtube />

				<Formula />

				<Table />

				<List format="bulleted-list" icon="format_list_bulleted" />
				<List format="numbered-list" icon="format_list_numbered" />

				<Quiz />

				<History format="undo" icon="undo" />
				<History format="redo" icon="redo" />
			</div>
		);
	case 'large':
		return (
			<div className={materialClassName}>
				<Heading icon="looks_one" format="heading-one" />
				<Heading icon="looks_two" format="heading-two" />
				<Heading icon="looks_3" format="heading-three" />

				<Mark format="bold" icon="format_bold" />
				<Mark format="italic" icon="format_italic" />
				<Mark format="underline" icon="format_underlined" />
				<Mark format="strikethrough" icon="strikethrough_s" />
				<Mark format="superscript" icon="superscript" />
				<Mark format="subscript" icon="subscript" />
				<Highlight />

				<Align />
				
				<Blockquote format="blockquote" icon="format_quote" />

				<Link />

				<Image folder={folder} path={path} />
				<Video folder={folder} path={path} />
				<Audio folder={folder} path={path} />
				<Download folder={folder} path={path} />
				<Youtube />

				<Formula />

				<Table />

				<List format="bulleted-list" icon="format_list_bulleted" />
				<List format="numbered-list" icon="format_list_numbered" />

				<History format="undo" icon="undo" />
				<History format="redo" icon="redo" />
			</div>
		);
	default:
		return (
			<div className={defaultClassName}>
				<Heading icon="looks_one" format="heading-one" />
				<Heading icon="looks_two" format="heading-two" />
				<Heading icon="looks_3" format="heading-three" />

				<Mark format="bold" icon="format_bold" />
				<Mark format="italic" icon="format_italic" />
				<Mark format="underline" icon="format_underlined" />
				<Mark format="strikethrough" icon="strikethrough_s" />
				<Mark format="superscript" icon="superscript" />
				<Mark format="subscript" icon="subscript" />
				<Highlight />

				<Align />
				
				<Blockquote format="blockquote" icon="format_quote" />

				<Link />

				<Image folder={folder} path={path} />
				<Video folder={folder} path={path} />
				<Audio folder={folder} path={path} />
				<Download folder={folder} path={path} />
				<Youtube />

				<Formula />

				<Table />

				<List format="bulleted-list" icon="format_list_bulleted" />
				<List format="numbered-list" icon="format_list_numbered" />

				<History format="undo" icon="undo" />
				<History format="redo" icon="redo" />
			</div>
		);
	}
});

export default Toolbar;
